import React from 'react';
import { Section, Stack, VStack, Box, Text, Gallery, Image, View, useViewState, InspectorImageWell , InspectorImageWellCondensed } from '@yapstudios/yap-content-builder';
import { InspectorHeader , InspectorControlButton, InspectorControlSelect, InspectorContent, InspectorProperty, InspectorControlText, InspectorControlDate, InspectorListItems, useInspectorState }  from '@yapstudios/yap-content-builder'

export default class ProductGalleryComponent {
    constructor() {
        this.products = [];
        this.type = 'product-gallery';
    }

    defaultProps() {
        return {
            style: 'image',
            products: [ 
                //{ src: null, description: null}
            ]
        };
    }

    decode(props) {
        const imageWidth  = 240
        const imageHeight = 240
        const spacing     = 16
        const paddingLeft = 20
        const paddingRight = 20

        const imageContent = props.products.map( (product, index) => { 
            return <ProductGalleryComponentItem galleryStyle={props.style} product={product} asset={product.asset} index={index} width={imageWidth} height={imageHeight}/>
        });

        const emptyContent = <EmptyPlaceholder title="Product Gallery" height={imageHeight}/>

        const content = (
            <Stack direction={"horizontal"} align={"leading"} justify={"leading"} spacing={spacing} width="100%" paddingLeft={paddingLeft} paddingRight={paddingRight} paddingBottom="20">
                {imageContent}
            </Stack>
        )

        const hasContent = props.products.length > 0
        const contentStyle = {  width: '100%' };
        const containerStyle = { "overflow": "scroll", width: '100%', paddingTop: '20px' };

        return (
            <Section padding="0" paddingTop="0" id="gallery-section" title="Gallery Image">
                <View id={"gallery"} model={props} inspector={this.inspector}>
                    <div className={"gallery-content"}  style={contentStyle}>
                        <div className={'gallery-container'}  style={containerStyle} >
                            {hasContent ? content : emptyContent}
                        </div>
                    </div>
                </View>
            </Section>
        )
    }

    inspector(model, updateModel) {

        // Add or replace an image
        const addImage = (asset, index) => {
            let newProduct = {
                asset: asset,
                title: "New Product"
            }

            if (index != null) {
                model.products[index] = newProduct
            } else {
                model.products.push(newProduct)
            }

            updateModel(model)
        }

        // Remove an image
        const deleteImage = (index) => {
            model.products.splice(index, 1);
            updateModel(model)
        }

        // Swap image places
        const moveImage = (oldIndex, newIndex) => {
            const moveItem = model.products[oldIndex];
            model.products[oldIndex] = model.products[newIndex];
            model.products[newIndex] = moveItem;
            updateModel(model)
        }

        // When style 'image' show the product name in the edit dialog
        var editContent = null
        if (model.style == 'image') {
            editContent = (index) => {
                let product = model.products[index]

                return (
                    <InspectorProperty title="Product Name">
                        <InspectorControlText value={product.title} onChange={v => {
                            model.products[index].title = v
                            updateModel(model)
                        }} /> 
                    </InspectorProperty>
                )
            }
        }

        const imageItems = model.products.map ((product, idx) => {
            const image = (
                <InspectorImageWell condensed={true} model={product.asset ?? {}} editContent={editContent} src={product.asset ? product.asset.src : null} onImageSelected={(asset) => {
                    addImage(asset, idx)
                }}></InspectorImageWell>
            )

            const text = (
                <InspectorControlText value={product.title} onChange={v => {
                    model.products[idx].title = v
                    updateModel(model)
                }} /> 
            )

            return (
                <VStack spacing={10}>
                    {model.style == 'image' && image}
                    {model.style != 'image' && text}
                </VStack>
            )
        })

        const addButton = (
            <InspectorControlButton title="Add Product" onClick={ () => {
                addImage(null, null)
            }}/>
        )        

        return (
            <InspectorContent>
                <InspectorHeader title={"Product Gallery"} />

                <InspectorProperty property={'style'} title={"Style"}>
                    <InspectorControlSelect value={model.style} options={['Text','Image']} keys={['text', 'image']} onChange={v => {
                        updateModel({ ...model, 
                                      style: v})
                    }} />
                </InspectorProperty>

                <InspectorProperty property={'products'} singleColumn={true} title={`Products`}>     
                    <Stack spacing={10}>
                        <InspectorListItems onDelete={deleteImage} onMove={moveImage} editContent={editContent}>
                            {imageItems}
                        </InspectorListItems>
                        {addButton}
                    </Stack>                         
                </InspectorProperty>   
                  
            </InspectorContent>
        )
    }

    encode(model, props) {
        // From inspector
        props = {...model}
        return props
    }

    icon() {
        return (
            <svg width="100" height="71" viewBox="0 0 100 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_156_2890)">
                <rect width="100" height="70" transform="translate(0 0.245972)" fill="white"/>
                <g clipPath="url(#clip1_156_2890)">
                <rect x="17.8337" y="16.2543" width="64.7159" height="44.6738" fill="#384CC0" fillOpacity="0.12"/>
                <path d="M24.6155 38.9877L20.3964 42.4457C18.7743 43.7753 17.8337 45.7873 17.8337 47.8847C17.8337 51.7507 20.9677 54.9377 24.8337 54.9377H75.8102C79.5323 54.9377 82.5497 51.9204 82.5497 48.1983C82.5497 45.92 81.3986 43.796 79.4899 42.5521L63.5148 32.141C61.1264 30.5845 58.0327 30.6319 55.6931 32.2608L43.7845 40.5521C41.3844 42.2231 38.1984 42.226 35.7954 40.5593L33.0421 38.6497C30.473 36.8678 27.0336 37.0058 24.6155 38.9877Z" fill="#384CC0"/>
                <ellipse cx="33.5935" cy="29.6276" rx="4.02356" ry="4.03194" fill="#384CC0"/>
                </g>
                <rect x="19.1917" y="17" width="62" height="37" rx="9" stroke="#384CC0" strokeOpacity="0.4" strokeWidth="2"/>
                <g opacity="0.4">
                <g clipPath="url(#clip2_156_2890)">
                <rect x="-50.358" y="16.2543" width="64.7159" height="44.6738" fill="#384CC0" fillOpacity="0.12"/>
                <path d="M-43.5762 38.9877L-47.7953 42.4457C-49.4175 43.7753 -50.358 45.7873 -50.358 47.8847C-50.358 51.7507 -47.224 54.9377 -43.358 54.9377H7.61854C11.3406 54.9377 14.358 51.9204 14.358 48.1983C14.358 45.92 13.2069 43.796 11.2982 42.5521L-4.67689 32.141C-7.06527 30.5845 -10.159 30.6319 -12.4986 32.2608L-24.4072 40.5521C-26.8073 42.2231 -29.9933 42.226 -32.3963 40.5593L-35.1496 38.6497C-37.7187 36.8678 -41.1581 37.0058 -43.5762 38.9877Z" fill="#384CC0"/>
                </g>
                <rect x="-49" y="17" width="62" height="37" rx="9" stroke="#384CC0" strokeOpacity="0.4" strokeWidth="2"/>
                </g>
                <g opacity="0.4">
                <g clipPath="url(#clip3_156_2890)">
                <rect x="85.642" y="16.2543" width="64.7159" height="44.6738" fill="#384CC0" fillOpacity="0.12"/>
                <path d="M92.4238 38.9877L88.2047 42.4457C86.5825 43.7753 85.642 45.7873 85.642 47.8847C85.642 51.7507 88.776 54.9377 92.642 54.9377H143.619C147.341 54.9377 150.358 51.9204 150.358 48.1983C150.358 45.92 149.207 43.796 147.298 42.5521L131.323 32.141C128.935 30.5845 125.841 30.6319 123.501 32.2608L111.593 40.5521C109.193 42.2231 106.007 42.226 103.604 40.5593L100.85 38.6497C98.2813 36.8678 94.8419 37.0058 92.4238 38.9877Z" fill="#384CC0"/>
                <ellipse cx="101.402" cy="29.6276" rx="4.02356" ry="4.03194" fill="#384CC0"/>
                </g>
                <rect x="87" y="17" width="62" height="37" rx="9" stroke="#384CC0" strokeOpacity="0.4" strokeWidth="2"/>
                </g>
                </g>
                <defs>
                <clipPath id="clip0_156_2890">
                <rect width="100" height="70" fill="white" transform="translate(0 0.245972)"/>
                </clipPath>
                <clipPath id="clip1_156_2890">
                <rect x="18.1917" y="16" width="64" height="39" rx="10" fill="white"/>
                </clipPath>
                <clipPath id="clip2_156_2890">
                <rect x="-50" y="16" width="64" height="39" rx="10" fill="white"/>
                </clipPath>
                <clipPath id="clip3_156_2890">
                <rect x="86" y="16" width="64" height="39" rx="10" fill="white"/>
                </clipPath>
                </defs>
            </svg>)

    }

}

function ProductGalleryComponentItem(props) {
    const { model, updateModel, viewId } = useViewState()
    const { asset , product, index, galleryStyle } = props 

    const imageOnChange = function (asset) {
        model.images[index] = {
            ...model.images[index],
            ...asset
        };
        updateModel(model);
    };

    const id = "gallery"

    const containerStyle = {
        boxShadow: '0px 5px 25px #00000020',
        borderRadius: '20px'
    }

    const imageComponent = galleryStyle == 'image' && asset && <Image borderRadius={4} readonly={true} key={id + "-image" + index} id={id + "-image" + index} src={asset.src} height={props.height} width={props.width} placeholder={true} onChange={imageOnChange} {...asset} />

    return (
        <div style={containerStyle}>
            <VStack padding={20} spacing={20} width={props.width}>
                {imageComponent ?? <Box height={props.height}/>}
                <VStack spacing={5}>
                    <Text align={"left"} content={product.title} readonly={true} style={"h3"}/>
                    <Text align={"left"} content={"Shop Now"} readonly={true} color={"accent"}  style={"h3"}/>
                </VStack>
            </VStack>
        </div>
    );
}

// Empty state
// TODO: Move to EmptyView component for other components to use
// 
function EmptyPlaceholder(props) {
        const emptyIcon = (
            <svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.01862 22.022C8.08046 22.022 7.3679 21.7857 6.88092 21.3131C6.39394 20.8404 6.15045 20.1386 6.15045 19.2076L9.77057 16.0601C9.97825 15.8883 10.1824 15.7594 10.3829 15.6734C10.5906 15.5803 10.7982 15.5338 11.0059 15.5338C11.2351 15.5338 11.4571 15.5767 11.6719 15.6627C11.8939 15.7486 12.1088 15.8883 12.3165 16.0816L14.046 17.6392L18.3858 13.7935C18.6078 13.593 18.837 13.4498 19.0733 13.3638C19.3096 13.2707 19.5639 13.2242 19.836 13.2242C20.0938 13.2242 20.348 13.2743 20.5987 13.3746C20.8493 13.4677 21.0785 13.6109 21.2862 13.8043L26.2706 18.5094V19.1969C26.2706 20.135 26.0271 20.8404 25.5401 21.3131C25.0531 21.7857 24.3406 22.022 23.4024 22.022H9.01862ZM13.2725 14.0406C12.6423 14.0406 12.1052 13.815 11.6612 13.3638C11.2172 12.9127 10.9952 12.372 10.9952 11.7418C10.9952 11.1259 11.2172 10.5924 11.6612 10.1412C12.1052 9.69002 12.6423 9.46443 13.2725 9.46443C13.6879 9.46443 14.0674 9.56827 14.4112 9.77596C14.7549 9.98364 15.0271 10.2629 15.2276 10.6138C15.4353 10.9576 15.5391 11.3336 15.5391 11.7418C15.5391 12.372 15.3171 12.9127 14.8731 13.3638C14.4291 13.815 13.8956 14.0406 13.2725 14.0406ZM3.67975 17.6178C2.5554 17.6178 1.71035 17.342 1.14459 16.7906C0.585999 16.232 0.306702 15.3977 0.306702 14.2877V4.15779C0.306702 3.04777 0.585999 2.21704 1.14459 1.6656C1.71035 1.10701 2.5554 0.827713 3.67975 0.827713H18.2354C19.3526 0.827713 20.1941 1.10701 20.7598 1.6656C21.3256 2.2242 21.6085 3.05493 21.6085 4.15779V6.49959H19.879V4.25447C19.879 3.69588 19.7322 3.27335 19.4385 2.98689C19.1449 2.70043 18.7331 2.55721 18.2032 2.55721H3.70123C3.16412 2.55721 2.75234 2.70043 2.46588 2.98689C2.17942 3.27335 2.03619 3.69588 2.03619 4.25447V14.2017C2.03619 14.7603 2.17942 15.1829 2.46588 15.4693C2.75234 15.7486 3.16412 15.8883 3.70123 15.8883H6.34381V17.6178H3.67975ZM8.98639 22.5914C7.86204 22.5914 7.01699 22.3121 6.45123 21.7535C5.89264 21.2021 5.61334 20.3713 5.61334 19.2613V9.13142C5.61334 8.0214 5.89264 7.19067 6.45123 6.63924C7.01699 6.08064 7.86204 5.80135 8.98639 5.80135H23.6602C24.7774 5.80135 25.6189 6.08064 26.1846 6.63924C26.7504 7.19783 27.0333 8.02856 27.0333 9.13142V19.2613C27.0333 20.3713 26.7504 21.2021 26.1846 21.7535C25.6189 22.3121 24.7774 22.5914 23.6602 22.5914H8.98639ZM9.00787 20.8619H23.628C24.1579 20.8619 24.5697 20.7187 24.8633 20.4322C25.157 20.1529 25.3038 19.734 25.3038 19.1754V9.2281C25.3038 8.66951 25.157 8.24698 24.8633 7.96053C24.5697 7.67407 24.1579 7.53084 23.628 7.53084H9.00787C8.47076 7.53084 8.05898 7.67407 7.77252 7.96053C7.48606 8.24698 7.34283 8.66951 7.34283 9.2281V19.1754C7.34283 19.734 7.48606 20.1529 7.77252 20.4322C8.05898 20.7187 8.47076 20.8619 9.00787 20.8619Z" fill="#B4B4B4"/>
            </svg>
        )

        const emptyStyle = {
            height: props.height + 'px',
            background: "#F1F1F1",
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#919191',
            fontWeight: '600',
            fontSize: '14px',
            padding: '20px'
        }

        const emptyContent = (
            <div style={ { 'padding' : '20px', paddingTop: '0px'}}>
                <div className="empty-content" style={emptyStyle}>
                    {emptyIcon}
                    <span>{props.title ?? "No Content"}</span>
                </div>
            </div>
        )
        
        return emptyContent
}